import { useMutation } from "@tanstack/react-query";

import Sentry from "@similarweb/sentry-logger";

import type { ISetupPromptsResponse } from "app/pages/digital-marketing/generative-ai/llm-tracker/homepage/types";
import { DefaultFetchService } from "app/services/fetchService";

const fetchService = DefaultFetchService.getInstance();
const getPromptsGenerationEndpoint = (campaignId: string): string =>
    `/api/aiTracker/campaigns/${campaignId}/prompts/generate`;

interface IGeneratePromptsParams {
    campaignId: string;
    domain: string;
    cultureName: string;
    topicName: string;
    count: number;
}

const generatePrompts = async ({
    campaignId,
    domain,
    cultureName,
    topicName,
    count,
}: IGeneratePromptsParams): Promise<ISetupPromptsResponse> => {
    return await fetchService.post(getPromptsGenerationEndpoint(campaignId), {
        domain,
        cultureName,
        topic: topicName,
        promptCount: count,
    });
};

export const useGeneratePrompts = () =>
    useMutation({
        mutationFn: generatePrompts,
        onError: (error, variables) => {
            Sentry.errorTracker({
                message: "Error generating prompts",
                e: error,
                level: "error",
                params: {
                    extra: {
                        domain: variables.domain,
                        cultureName: variables.cultureName,
                        topic: variables.topicName,
                        count: variables.count,
                    },
                },
            });
        },
    });
